import { render, staticRenderFns } from "./support-email.vue?vue&type=template&id=5b6738dc&"
import script from "./support-email.vue?vue&type=script&lang=js&"
export * from "./support-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.9.8_0aadd186e864c83cab1284bae568d6ae/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports